import type { FeatureGateProps, FeatureGateResult } from "./base";

type FeatureGateRenderProps = {
	enabled: boolean;
	stats?: {
		available: boolean;
		current: number;
		quota: number;
		period?: string;
		periodReset?: string;
	};
	details?: FeatureGateResult[];
} & FeatureGateProps;

/**
 * Render the feature gate can either render as a render prop or as a children with an optional fallback component
 *
 * @param props - The props
 * @returns The rendered feature gate
 */
export const FeatureGateRender = (props: FeatureGateRenderProps) => {
	const { enabled, stats } = props;

	if ("render" in props && props.render) {
		return props.render({ enabled, stats, details: props.details });
	}

	if (enabled) {
		return props.children;
	}

	return props.fallbackComponent ?? null;
};
